<template lang="pug">
  modal.modal(:title='modalTitle' @closeModal='hideModal')
    .loader.width-100.row.middle.center(v-if='loading')
      loader(size='inner')
    .width-100.m-top-2(v-else)
      content-list(v-if='step === 1' :fromProgram='fromProgram' @next='changeStep(true)')
      use-form(v-if='step === 2' @submit='submit' @prev='changeStep(false)')
</template>

<script>
import Modal from '@/components/Modal'
import { mapActions, mapState } from 'vuex'
import { i18n } from '@/main'
import ContentList from './ContentList'
import UseForm from './UseForm'
import Loader from '@/components/Loader'
import { routes } from '../../router'
import userRole from '../../mixins/userRole'

export default {
  mixins: [userRole],
  components: { Modal, ContentList, UseForm, Loader },
  data() {
    return {
      step: 1,
      loading: true
    }
  },
  async created() {
    if (this.isAdmin) await this.hydrateSchoolsWithCourses()
    await this.hydrateContentResources({
      programId: this.modalProps.programId,
      resourceId: this.modalProps.resourceId,
      locale: this.innerLocale || this.locale
    })
    this.loading = false
  },
  computed: {
    ...mapState({
      modalProps: state => state.behavior.registerUseModal.props,
      innerLocale: state => state.behavior.innerLocale,
      locale: state => state.behavior.locale
    }),
    fromProgram() {
      return this.$route.name === routes.educationalProgram
    },
    modalTitle() {
      return i18n.t(`registerUseModal.titles.${this.step}`)
    }
  },
  methods: {
    ...mapActions([
      'registerUsedContent',
      'showElement',
      'hideElement',
      'hydrateContentResources',
      'hydrateSchoolsWithCourses'
    ]),
    hideModal() {
      this.hideElement({ element: 'registerUseModal' })
    },
    changeStep(next) {
      next ? this.step = this.step + 1 : this.step = this.step - 1
    },
    async submit(data) {
      this.loading = true
      await this.registerUsedContent({ recordInfo: data, fromProgram: this.fromProgram })
      this.loading = false
      this.hideElement({ element: 'registerUseModal' })
      this.fromProgram
        ? this.showElement({ element: 'successModal', props: { title: i18n.t('registerUseModal.success') } })
        : this.showElement({ element: 'feedbackModal' })
    }
  }
}
</script>

<style lang="scss" scoped>

.loader{
  height: 350px;
}
</style>
